<template>
	<div class="investmentClues" data-title="重点产业的重点城市线索">
		<leftnav class="fl" mkcode="C" :itemcode="(curWebsite.type == 5 || curWebsite.type == 6)? 'C-ZDCYZDCS':'C-GDXSTJ'" ></leftnav> 
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<!-- 头部盒子开始 -->
				<div class="whitebox right_topbox " style="padding-bottom: 5px;">
					<div class="right_boxtitle">
						<span class="fl right_title" v-if="curWebsite.type != 5 && curWebsite.type != 6">{{curWebsite.keyword}}{{curWebsite.type == 2 ?'':'线索'}}</span>
						<span class="fl right_title" v-if="curWebsite.type == 5 || curWebsite.type == 6">产业排行榜</span>
						<cluetips></cluetips>
						<span class="fr showechart-c6" @click="showechart=!showechart">{{showechart?'隐藏':'查看'}}图表</span>
						<video-teaching :type="3" seat="top"></video-teaching>
					</div>
					<!-- 筛选项开始 -->
					<div class="opport-screen-list1">
						<div class="spage-searchbox ">
							<ClueNav tabCode="zdcyzdcs"></ClueNav>
						</div>
						<dl class="opport-screen bdbe">
							<dt class="fl">重点产业</dt>
							<dd class="fl">
								<span :class="{'a-screen':true,'current':notioncode1 == item.value}"
									v-for="(item,i) in hotnotionlist" :key="item.label+i" @click="getnotioncode(item,1)">{{item.label}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="hotnotionchildren.length>1">
							<dt class="fl titleop">细分产业</dt>
							<dd class="fl">
									<span :class="{'a-screen':true,'current':notioncode2 == item.value}" v-for="(item,index)  in hotnotionchildren" :key="item.label+index" @click="getnotioncode(item,2)">{{item.label}} </span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe">
							<dt class="fl">重点城市</dt>
							<dd class="fl">
								<span :class="{'a-screen':true,'current':cityid == item.id || proid == item.id}" v-for="item in hotcitylist" :key="item.id" @click="getcityid(item)">{{item.name}}<em class="num">({{item.count>0?item.count:''}})</em></span>
							</dd>
						</dl>
					</div>
					<!-- 筛选项结束 -->
				</div>
				<!-- 头部盒子结束 -->
				<!-- 柱状图 概念企业数量 -->
				<div class="fixedEchartmap" v-show="showechart && userdata.token">
					<!-- <h4 class="fl">{{notiontext}}-全国重点城市分布图</h4> -->
					<div id="fixedEchartMap"></div>
					<div id="fixedEchartBar"></div><span class="closebtn" @click="showechart=false"></span>
				</div>
				<!-- 表格内容开始 -->
				<div class="whitebox columnbox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
					</div>
					<!-- 多维度分数筛选 -->
					<ul class="dimensionScreen oh w95mg">
						<li :class="orderField == list.type ?'fl current ':'fl '"   v-for="(list,index) in dimensionList" :key="'orderField'+index" @click="tablesort(list.type);"><span
									:class="{'sortname ':true,'current':orderField == list.type,'fz15':list.name.length>5}">{{list.name}}</span><span
								:class="orderType == 1?'timesorticon up':'timesorticon down'"></span></li>
					</ul>
					<!-- 热门产业全部企业 -->
					<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>投资力度</th>
								<th>编辑</th>
							</tr>
							<tr v-for="(list,index) in enterpristlist" :key="list.title+list.stockCode">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<td class="title" @click="routerlinkid('/enterprises',list.stockCode,9,'',curindex)">
									{{list.title}}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="item in list.notionlist" :key="item.id"
										@click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name,'all')">{{item.name}}</span>
								</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="item in list.taglist" :key="item.id"
										@click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name,'all')">{{item.name}}{{item.count}}</span>
								</td>
								<td>{{list.area}}</td>
								<td>{{list.zs100000}}</td>
								<td>{{list.zs200000}}</td>
								<td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br/>目标企业</span></td>
							</tr>
						</table>
					</div>
					<!-- 表格内容结束 -->
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		dataInJs
	} from "../../utils/city.js";
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'investmentClues7',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				title: "重点产业的重点城市线索",
				isShowFreeUserTips: false,
				userdata:{},curWebsite:this.$api.getWebsiteType(),  
				showechart: true,
				hotnotionlisttr:"&高端装备&汽车产业&新一代信息技术&新材料&新能源&生物医药&",
				hotnotionlist: [{
						value: "A01",
						label: "高端装备"
					}, {
						value: "A02",
						label: "汽车产业"
					}, {
						value: "A03",
						label: "新一代信息技术"
					}, {
						value: "A04",
						label: "新材料"
					},
					{
						value: "A05",
						label: "新能源"
					}, {
						value: "A06",
						label: "生物医药"
					},
				], 
				notionlistApi:[],//api后台概念数据
				hotnotionchildren:[], childreAllString:'',notioncode1:'A01',notioncode2:"A01",
				notionCode: "A01",
				notiontext: "高端装备",
				hotcitylist: [{
					id: 0,
					name: '全国',
					count: 0
				}],
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				allcitylist: [{
					id: 0,
					name: '全国',
					count: 0
				}],
				flages: true,
				searchtype: 6, //线索类型 2以商招商 1本省投资概率 3关键融资 4热点产业企业 5.重城重产 
				// notionCodearr:[{code:'A0101'},{'A0201'},{'A0301'},{'A0501'},{'A0502'},{'C01'},{'A0308'},{'A0313'},{'A0317'},{'A0504'},{'A0601'}], 
				proid: 0,
				cityid: 0,
				cityname: "北京市",
				enterpristlist: [],
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数 
				totalPage: 1,
				maxPage: 10, //最大页数  
				areadata: dataInJs(), //省份城市数据
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序 
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				dimensionList: [{
					name: '综合',
					type: 0
				}, {
					name: '企业实力',
					type: 2
				}, {
					name: '投资力度',
					type: 3
				}, {
					name: '本省关联度',
					type: 4
				}, {
					name: '拿地数量',
					type: 5
				}, {
					name: '拿地面积',
					type: 6
				}, {
					name: '拿地金额',
					type: 7
				}, {
					name: '投资项目数量',
					type: 8
				}, {
					name: '投资项目金额',
					type: 9
				}],
				// ,{name:'控制企业数量',type:10},{name:'专利数量',type:11},
			}
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			var _this = this;
			this.userdata = this.getuseriformation();

		},
		mounted() {
			document.getElementById('app').style.background = "#f0f3f5";
			this.getapiNotionlist();
			this.getcompanylist(1, 'notion');
		},
		methods: {
			//获取后台api的三大概念数据存值
			getapiNotionlist(){
				var _this=this; 
				this.$axios.get(this.$api.tag.notion.list() + '?level=3', {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log(res.data)
					if (res.data.success) {
						// console.log('三大产业概念数据',res.data.list)
						_this.hotnotionlist=res.data.list[0].children.filter(list=>{ 
							return _this.hotnotionlisttr.indexOf(list.label)>0; 
						}); 
						var hotnotionchildrens=_this.hotnotionlist[0].children;
						var ddsg=[{label:"全部",value:_this.hotnotionlist[0].value}];
						// hotnotionchildrens.unshift();
						_this.hotnotionchildren=ddsg.concat(hotnotionchildrens);
				 // console.log('hotnotionlist',res.data.list[0].children,_this.hotnotionlisttr,_this.hotnotionlist);
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//热门城市点击
			getcityid(list) {
				if(!this.userdata.token){
						this.isShowFreeUserTips = true;
						return;
					} 
				if (list.id < 100) {
					this.proid = list.id;
					this.cityid = 'all';
				} else {
					this.proid = 'all';
					this.cityid = list.id;
				}
				this.cityname = list.name;
				// this.notionCode=this.allnotionlist[0].code;
				this.getcompanylist();
			},
			//热门产业点击
			getnotioncode(list,type) {
				if(!this.userdata.token){
						this.isShowFreeUserTips = true;
						return;
					} 
				if (list.code == this.notionCode) {
					return;
				}
				var hotnotionchildren=[];
				if(type == 1){
					this.notioncode1 = list.value;  
					hotnotionchildren=list.children;
					console.log(list.children);
					hotnotionchildren.unshift({label:"全部",value:list.value});
					this.hotnotionchildren=hotnotionchildren;
				}else if(type == 2){
					
				}
				this.notioncode2 = list.value;
				this.notionCode = list.value;
				this.notiontext = list.label; 
				this.proid=0;	this.cityid = 0;
				this.getcompanylist(1, 'notion');
			},
			// pageHandler: function(page) {
			// 	this.page = page;
			// 	this.getcompanylist(page);
			// },
			pageHandler: function(page) { 
				this.getcompanylist(page);  
			},
			//时间/分数升降序
			tablesort(field) {
				if(!this.userdata.token){
						this.isShowFreeUserTips = true;
						return;
					} 
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getcompanylist();
			},
			getcompanylist(page, type) {
				this.bus.$emit('loading', true);
				// console.log('getcompanylist');
			this.page=page?page:1;
				var _this = this;
				//获取企业列表
				var notionja = this.splicing('notion', this.notionCode);
				var cityja = this.splicing('city', this.cityid);
				var provja = this.splicing('province', this.proid);
				var mapbtn='';
					if (type == 'notion') { 
						mapbtn='&calCity=1';
					}
				var ajaxurl = this.$api.cyl.enterprise.list() + '?type=0&search=1&page=' + this.page + provja +mapbtn + cityja + notionja +'&orderField=' + this.orderField + '&orderType=' + this.orderType;
				console.log(ajaxurl);
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log('省份城市列表',res.data)
					var citycountlist = res.data.cityList;
					if (res.data.success) { 
						if (type == 'notion') { 
								_this.allcitylist[0].count = res.data.totalRecord;
							var sdt = _this.citynumsort(citycountlist);
							_this.hotcitylist = _this.allcitylist.concat(sdt); 
							_this.chianmapFun('fixedEchartMap',sdt);
							_this.rankFun('fixedEchartBar',sdt.splice(0,10)); 
							_this.flages = false;
						}
						console.log('获取企业列表', res.data);
						_this.enterpristlist = res.data.list;
						for (var i = 0; i < res.data.list.length; i++) {
							_this.enterpristlist[i].taglist = _this.taglistfun(_this.enterpristlist[i].tag, _this
								.enterpristlist[i].tagCode);
							_this.enterpristlist[i].notionlist = _this.taglistfun(_this.enterpristlist[i].notion,
								_this.enterpristlist[i].notionCode);
						}

						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.haspage = res.data.list.length == res.data.pageSize;
						_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//将重点城市数量从省级一下剥夺出来
			citynumsort(data) {
				let arr = [];
				for (var i = 0; i < data.length; i++) {
					if (data[i].name.indexOf('市') > 0) {
						arr.push({
							name: data[i].name,
							id: data[i].id,
							count: data[i].count,
						})
					} else {
						var arr1 = data[i].children;
						for (var d = 0; d < arr1.length; d++) {
							arr.push({
								name: arr1[d].name,
								id: arr1[d].id,
								count: arr1[d].count,
							})
						}
					}
				} 
				let arr2 = [];
				// 将需要排序的 key, 按照 "从大到小" 进行排列
				let sortKeys = Object.keys(arr).sort((a, b) => {
					return arr[b].count - arr[a].count;
				})
				// 循环排列好的 key, 重新组成一个新的数组
				for (var sortIndex in sortKeys) {
					arr2.push(arr[sortKeys[sortIndex]])
				}
				return arr2.slice(0, 20);
			},
			//弹出图表 概念企业数量排名
			rankFun(el, data) {
				var charPie3currentIndex = 0,
					isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var chart = echarts.init(document.getElementById(el));
				var _this = this,
					xline = [],
					seriesline = [];
				var datalen = data.length - 1;
				for (var i = 0; i < data.length; i++) {
					xline.push(data[datalen - i].name);
					seriesline.push(data[datalen - i].count);
				};
				// console.log(data,xline,seriesline)
				var option = {
					title: {
						// text:_this.cityname+'重点产业',
						text: '',
						right: 0,
						bottom: 20,
						textStyle: {
							color: '#333',
							fontSize: 16
						}
					},
					tooltip: {
						formatter: "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff'></span>{b}：{c}"
					},
					color: _this.colors,
					grid: { containLabel: true },
					label: {
						show: true,
						position: 'right',
						valueAnimation: true,
						color: '#333',
						formatter: '{@score}'
					},
					xAxis: {
						type: 'value',
						axisTick: {
							show: false
						},
						boundaryGap: [0, 0.01],
						splitLine: {
							show: true
						},
						axisLabel: {
							fontSize: 13,
							color: '#333'
						}
					},
					yAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: true
						},
						data: xline,
						axisLabel: {
							fontSize: 13,
							color: '#333'
						}
					},
					series: [{
						data: seriesline,
						type: 'bar',
						barWidth: 10,
					}]
				};
				chart.setOption(option);

			},
			//拿地项目地图分布
			chianmapFun(el, data) {
				console.log(this.notiontext,'chianmapFun')
				var myChart = echarts.init(document.getElementById(el));
				var loadedDataURL = 'map/china.json';
				// 注意引入版本 
				var geoCoordMap = this.$geoJson;
				data=data.slice(0,20); 
				var _this=this;
				$.getJSON(loadedDataURL, function(geoJson) { 
					// 注册地图名字(tongren)和数据(geoJson) 
					echarts.registerMap('china', geoJson);
					var scaData = [],
						maptitle = ''; 
					maptitle = _this.notiontext+'-全国重点城市分布'; 
					for (var i = 0; i < data.length; i++) { 
						var geoCoord = geoCoordMap[data[i].name]; 
						// console.log(geoCoord)
						if (geoCoord) { 
							scaData.push({
								name: data[i].name,
								value: geoCoord.concat(data[i].count), //新值= 坐标+旧值；
								id: data[i].id,
							});
						}else{
							console.log(data[i].name,data[i].count);
						}
					}

					var option = {
						backgroundColor: '#fff',
						title: {
							text: maptitle,
							left: 'center',
							top: 20,
							textStyle: {
								color: '#666',
								fontSize: 16
							}
						},
						tooltip: { //提示框组件
							trigger: 'item',
							formatter: function(params) {
								// console.log(params)
								return params.name;
							},
							show: true,
						},

						legend: { //图例
							orient: 'vertical',
							show: false,
							y: 'bottom',
							x: 'right',
						},
						geo: {
							map: "china",
							silent: true,
							// layoutCenter: ['49%', '49%'],
							layoutSize: '100%',
							roam: false,
							center: [105.87, 38],
							zoom: 1,
							label: {
								show: true,
								textStyle: {
									color: '#fff'
								}
							},
							itemStyle: {
								normal: {
									areaColor: "#2e579d",
									borderColor: "#fff"
								},
								emphasis: {
									areaColor: "#fff"
								}
							}
						},
						series: [{
							name: '',
							type: 'effectScatter',
							coordinateSystem: 'geo',
							data: scaData, //选取从 start 到数组结尾的所有元素，该方法并不会修改数组，而是返回一个子数组 
							symbolSize: function(val) {
								var ddd = 10,
									val1 = val[2];
								if (val1 < 1000 && val1 > 500) {
									ddd = 10 + parseInt(val1 / 300);
								} else if (val1 > 1000) {
									var snum = parseInt(val1 / 1000);
									ddd = 15 + snum;
								}
								// console.log(val,ddd);
								return ddd;
							},
							showEffectOn: 'render',
							rippleEffect: {
								brushType: 'stroke'
							},
							tooltip: {
								show: true,
								formatter: function() {},
							},
							hoverAnimation: true,
							label: {
								normal: {
									formatter: '{b}:{@2}',
									position: 'right',
									show: false
								},
								emphasis: {
									show: true
								}
							},
							itemStyle: {
								normal: {
									color: '#f4e925',
									shadowBlur: 10,
									shadowColor: '#333'
								}
							},
							zlevel: 1
						}, ]
					};

					option.series[0].tooltip.formatter = function(params) { 
						return '<span style="font-size:15px;line-height:20px;margin-bottom:5px">'+params.name+':'+params.value[2]+'</span>';
					} 
					myChart.setOption(option);

				})
			}
		},
	}
</script>

<style>
	/* 提示框箭头 */
	.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
		border-top-color: #E0E8F9;
	}

	.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
		border-top-color: #E0E8F9;
	}

	/* 提示框背景色 */
	.atooltip {
		background: #E0E8F9 !important;
	}
</style>
